import { combineReducers } from "redux";
import {
  PRODUCT_CLEAR_ACTIVE,
  PRODUCT_CREATE,
  PRODUCT_GET_BY_ID,
  PRODUCT_PATCH,
  PRODUCT_SEARCH,
} from "../actions/products";
import { publishActionToast } from "../services/toasts";

const successToasts = {
  [PRODUCT_CREATE]: "Create product successfully",
  [PRODUCT_PATCH]: "Updated product successfully",
};

const byId = (state = {}, action) => {
  publishActionToast(action, "PRODUCT_", successToasts);

  switch (action.type) {
    case `${PRODUCT_SEARCH}_SUCCESS`:
    case `${PRODUCT_GET_BY_ID}_SUCCESS`:
    case `${PRODUCT_CREATE}_SUCCESS`:
    case `${PRODUCT_PATCH}_SUCCESS`:
      return {
        ...state,
        ...action.response.entities.product,
      };

    default:
      break;
  }

  return state;
};

const defaultActive = {
  dashboard: [],
  dashboardLastUpdate: 0,
  activeProduct: null,
  lastEdit: 0,
  error: null,
  pagination: {
    offset: 0,
    pageSize: 50,
    resultCount: 0,
  },
};

const active = (state = defaultActive, action) => {
  switch (action.type) {
    case PRODUCT_CLEAR_ACTIVE:
      return {
        ...defaultActive,
      };

    case `${PRODUCT_SEARCH}_SUCCESS`:
      return {
        ...state,
        dashboard: [...action.response.result],
        dashboardLastUpdate: new Date().getTime(),
        pagination: {
          ...action.response.pagination,
          pageSize: defaultActive.pagination.pageSize,
        },
      };

    case `${PRODUCT_GET_BY_ID}_SUCCESS`:
      return {
        ...state,
        activeProduct: action.response.result,
      };

    case `${PRODUCT_CREATE}_SUCCESS`:
    case `${PRODUCT_PATCH}_SUCCESS`:
      return {
        ...state,
        activeProduct: action.response.result,
        lastEdit: new Date().getTime(),
      };

    default:
      break;
  }

  return state;
};

export default combineReducers({
  active,
  byId,
});

export const getActiveProduct = (state) =>
  state.active.activeProduct ? state.byId[state.active.activeProduct] : null;
export const getAll = (state) =>
  state.active.dashboard.map((id) => state.byId[id]);
export const getPagination = (state) => state.active.pagination;
export const getLastEdit = (state) => state.active.lastEdit;
